import React, { useEffect, useState } from "react";

const links = [
  { label: "The Three", href: "#the-three" },
  { label: "About", href: "#about" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Future", href: "#future" },
  { label: "Writing", href: "#writing" },
  { label: "Book", href: "#book" },
  { label: "Contact", href: "#contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/70 border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="nav-logo">
          <span className="w-9 h-9 border border-gold/60 flex items-center justify-center font-serif text-gold text-xl group-hover:bg-gold group-hover:text-black transition-all duration-300">
            R
          </span>
          <span className="hidden sm:flex flex-col leading-none">
            <span className="font-serif text-white text-lg tracking-tight">Ryan Best</span>
            <span className="font-mono uppercase text-[10px] tracking-[0.28em] text-gold/70 mt-0.5">
              Entrepreneur
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/50 hover:text-gold transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#book"
          data-testid="nav-cta-work-with-ryan"
          className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 border border-gold/60 text-gold font-mono text-[10px] uppercase tracking-[0.25em] hover:bg-gold hover:text-black transition-all duration-300"
        >
          Book a Call
        </a>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="lg:hidden w-10 h-10 flex flex-col justify-center items-center gap-1.5 text-gold"
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          <span className={`w-6 h-px bg-gold transition-all ${menuOpen ? "rotate-45 translate-y-[6px]" : ""}`} />
          <span className={`w-6 h-px bg-gold transition-all ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`w-6 h-px bg-gold transition-all ${menuOpen ? "-rotate-45 -translate-y-[6px]" : ""}`} />
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-gold-deep/40" data-testid="nav-mobile-menu">
          <div className="px-8 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setMenuOpen(false)}
                className="font-mono text-xs uppercase tracking-[0.28em] text-white/60 hover:text-gold transition-colors"
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#book"
              onClick={() => setMenuOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 border border-gold/60 text-gold font-mono text-[10px] uppercase tracking-[0.25em] hover:bg-gold hover:text-black transition-all"
              data-testid="nav-mobile-cta"
            >
              Book a Call
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
